import React from 'react'
import Navbar from './Navbar'

export default function Wrapper( { children } ) {
  return (
    <div className="h-full bg-gray-200">
        <Navbar />
        {/* <header class="sticky h-20 top-0 z-50 w-full bg-red-500"></header> */}
        <div className="relative md:ml-[250px] lg:ml-[250px] bg-[#F6F6F6] h-full px-5 py-1">
          {children}
        </div>
    </div>
  )
}
